import { TagColor as Color } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export enum PerformanceReviewProcessTargetPeerAssignmentStatusEnum {
  Pending = 'pending',
  Assigned = 'assigned',
}

const getStatusInfo = (
  peerAssignmentStatus: PerformanceReviewProcessTargetPeerAssignmentStatusEnum
): { color: Color; label: string } => {
  switch (peerAssignmentStatus) {
    case PerformanceReviewProcessTargetPeerAssignmentStatusEnum.Pending:
      return {
        color: Color.grey,
        label: i18n.t(
          'performance_process.reviews.peer_management.peer_assignments_status.pending'
        ),
      }
    case PerformanceReviewProcessTargetPeerAssignmentStatusEnum.Assigned:
      return {
        color: Color.correct,
        label: i18n.t(
          'performance_process.reviews.peer_management.peer_assignments_status.assigned'
        ),
      }
  }
}

export const tagColor = (
  peerAssignmentStatus: PerformanceReviewProcessTargetPeerAssignmentStatusEnum
) => {
  const statusInfo = getStatusInfo(peerAssignmentStatus)
  return statusInfo.color
}

export const tagLabel = (
  peerAssignmentStatus: PerformanceReviewProcessTargetPeerAssignmentStatusEnum
) => {
  const statusInfo = getStatusInfo(peerAssignmentStatus)
  return statusInfo.label
}
